import { a as _applyDecoratedDescriptor, _ as _defineProperty, b as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-ec67cb00.js';
import { bind, next, throttle } from '@ember/runloop';
import service from '../-private/service.js';
import Component from '@glimmer/component';
import 'rsvp';
import '@ember/application';
import '@ember/service';
import '../animate.js';
import '@ember/array';
import '@ember/object/internals';
import '../constraints.js';
import MutationObserver from '../mutation-observer.js';
import '../velocity-ext.js';
import { measure } from '../utils/animate.js';
import { modifier } from 'ember-modifier';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div {{this.setup}}>\n	{{yield}}\n</div>\n");

var _dec, _class, _descriptor;
const WINDOW_RESIZE_THROTTLE_DURATION = 100;
let LiquidMeasuredComponent = (_dec = service('liquid-fire-transitions'), (_class = class LiquidMeasuredComponent extends Component {
  constructor() {
    super(...arguments);

    // this._destroyOnUnload = bind(this, this._destroyOnUnload);
    _defineProperty(this, "_didSetup", false);
    _defineProperty(this, "setup", modifier(element => {
      if (this._didSetup) {
        return;
      }
      this._didSetup = true;
      this.element = element;
      const self = this;

      // This prevents margin collapse
      this.element.style.overflow = 'auto';
      this.didMutate();
      this.observer = new MutationObserver(function (mutations) {
        self.didMutate(mutations);
      });
      this.observer.observe(this.element, {
        attributes: true,
        subtree: true,
        childList: true,
        characterData: true
      });
      this.windowResizeHandler = bind(this, this.windowDidResize);
      window.addEventListener('resize', this.windowResizeHandler);
      this.element.addEventListener('webkitTransitionEnd', function () {
        self.didMutate();
      });
      // Chrome Memory Leak: https://bugs.webkit.org/show_bug.cgi?id=93661
      // window.addEventListener('unload', this._destroyOnUnload);
    }));
    _initializerDefineProperty(this, "transitionMap", _descriptor, this);
  }
  willDestroy() {
    super.willDestroy();
    if (this.observer) {
      this.observer.disconnect();
    }
    window.removeEventListener('resize', this.windowResizeHandler);
    // window.removeEventListener('unload', this._destroyOnUnload);
  }
  didMutate() {
    // by incrementing the running transitions counter here we prevent
    // tests from falling through the gap between the time they
    // triggered mutation the time we may actually animate in
    // response.
    const tmap = this.transitionMap;
    tmap.incrementRunningTransitions();
    next(this, function () {
      this._didMutate();
      tmap.decrementRunningTransitions();
    });
  }
  windowDidResize() {
    throttle(this, this.didMutate, WINDOW_RESIZE_THROTTLE_DURATION);
  }
  _didMutate() {
    if (!this.element) {
      return;
    }
    this.args.didMeasure(measure(this.element));
  }

  // _destroyOnUnload() {
  //   this.willDestroyElement();
  // }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "transitionMap", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
setComponentTemplate(TEMPLATE, LiquidMeasuredComponent);

export { LiquidMeasuredComponent as default };
//# sourceMappingURL=liquid-measured.js.map
